import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";

const base =
    "group inline-flex items-center justify-center gap-2 rounded-full text-sm font-semibold transition-all duration-300 ease-premium focus:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:opacity-50";

const sizes = {
    md: "px-5 py-2.5",
    lg: "px-7 py-3.5 text-[15px]",
};

const variants = {
    primary:
        "bg-navy text-white hover:-translate-y-0.5 hover:shadow-[0_16px_40px_-12px_hsl(var(--navy)/0.6)]",
    dark: "bg-foreground text-background hover:-translate-y-0.5 hover:shadow-[0_16px_40px_-12px_rgba(0,0,0,0.35)]",
    secondary:
        "border border-border bg-background/60 text-foreground hover:-translate-y-0.5 hover:border-navy/50 hover:text-navy hover:bg-secondary",
    navy: "bg-navy text-white hover:-translate-y-0.5 hover:shadow-[0_16px_40px_-12px_hsl(var(--navy)/0.6)]",
};

export function Cta({
    children,
    to,
    href,
    onClick,
    type,
    variant = "primary",
    size = "md",
    withArrow = true,
    className,
    testId,
    ...rest
}) {
    const cls = cn(base, sizes[size], variants[variant], className);
    const inner = (
        <>
            {children}
            {withArrow && (
                <ArrowUpRight
                    className="h-4 w-4 transition-transform duration-300 ease-premium group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
                    strokeWidth={2}
                />
            )}
        </>
    );

    if (to) {
        return (
            <Link to={to} className={cls} data-testid={testId} {...rest}>
                {inner}
            </Link>
        );
    }
    if (href) {
        return (
            <a href={href} className={cls} data-testid={testId} {...rest}>
                {inner}
            </a>
        );
    }
    return (
        <button
            type={type || "button"}
            onClick={onClick}
            className={cls}
            data-testid={testId}
            {...rest}
        >
            {inner}
        </button>
    );
}
